import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilService } from 'src/app/service/util.service';
import { environment } from '../../../environments/environment';
import { LocationStrategy } from '@angular/common';
import * as CONSTANTS from '../../constants';
import { ApplicantDetailsService } from 'src/app/service/applicant-details.service';
@Component({
  selector: 'app-co-applicant-flow-start',
  templateUrl: './co-applicant-flow-start.component.html',
  styleUrls: ['./co-applicant-flow-start.component.less']
})
export class CoApplicantFlowStartComponent implements OnInit {
  preQualObj: any;
  showFlag = false;
  message = false;
  prequalType = 'P';
  switchType = 'S';

  constructor(private router: Router, private _activatedRoute: ActivatedRoute, private util: UtilService,
    private location: LocationStrategy, private applicanDetails: ApplicantDetailsService) {
    let progressPercent1 = sessionStorage.getItem("progressPercentage");

    if (Number(progressPercent1) == CONSTANTS.PROGRESS_PERCENTAGE.CIBC_RELATION) {
    }
    if ((Number(progressPercent1) == CONSTANTS.PROGRESS_PERCENTAGE.CONCENT_FIRST || Number(progressPercent1) == CONSTANTS.PROGRESS_PERCENTAGE.CONCENT_FIRST_APPLICANT || Number(progressPercent1) == CONSTANTS.PROGRESS_PERCENTAGE.CONSENT_CO_APPLICANT || Number(progressPercent1) == CONSTANTS.PROGRESS_PERCENTAGE.VERIFY_YOUR_1_IDENTITY_PRIMARY || Number(progressPercent1) == CONSTANTS.PROGRESS_PERCENTAGE.VERIFY_YOUR_IDENTITY_PRIMARY || Number(progressPercent1) == CONSTANTS.PROGRESS_PERCENTAGE.VERIFY_YOUR_IDENTITY_PRIMARY_2_CUSTOMER || Number(progressPercent1) == CONSTANTS.PROGRESS_PERCENTAGE.CIBC_RELATIONSHIP_2_CUSTOMER || sessionStorage.getItem("olbRedirect") == btoa("oblredirectedCoApp")) && (Number(progressPercent1) != CONSTANTS.PROGRESS_PERCENTAGE.CIBC_RELATION)) {
      this.util.progressPercent.next(0);
    } else {
      this.util.progressPercent.next(0);
    }
    this.util.sidebarTitle.next('slideTitles.coApplicantFlowStart');
    this.util.isSidebarVisible.next(true);
  }

  ngOnInit(): void {
    this.location.onPopState(() => {
      history.pushState(null, null, window.location.href);
    });
    history.pushState(null, null, window.location.href);
    window.onpopstate = () => setTimeout(() => {
    }, 0);

    setTimeout(() => {
      this.util.getJson(atob(sessionStorage.getItem("transactionid"))).subscribe((result: any) => {
        this.preQualObj = result;
        if (this.preQualObj.failure_code == "0004") {
          this.message = true;
        }
        else {
          this.message = false;
        }
      }
        , (error) => {
          this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
        })
    }, 0)


  }

  ngAfterViewInit() {
    document.getElementById("sidebarTitle").focus();
  }
  onContinue() {
    if (this.preQualObj.is_coapplicant_applied == 'Y' && this.preQualObj.are_both_applicants_CIBC_customer == 'N') {
      this.router.navigate(['../personal-information-about-yourself'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
    }
    if (this.preQualObj.is_coapplicant_applied == 'Y' && this.preQualObj.are_both_applicants_CIBC_customer == 'Y') {
      var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      sessionStorage.setItem("olbRedirect", btoa("oblredirected"));
      let channel = isMobile == true ? 'mobi' : 'olb';
      sessionStorage.setItem("redTime", String(new Date().getTime()));
      let callbackurl: string
      if (environment.api.enable_callback == "true" && environment.api.authentication == "cah") {
        callbackurl = environment.backend_base_url + "authenticationUtil/cah-auth-response";
        const encodedCallbackurl = encodeURIComponent(callbackurl);
        if (this.preQualObj.flow_type == this.prequalType)
          window.location.href = environment.api.cahSignin + "client_id=" + environment.api.clientId + "&redirect_uri=" + encodedCallbackurl + "&state=PQ_" + atob(sessionStorage.getItem("transactionid")) + "&nonce=prequalification_" + atob(sessionStorage.getItem("transactionid")) + "&ui_locales=" + sessionStorage.getItem("currLang") + "-CA" + "&scope=openid&prompt=login&response_type=code";
        else
          window.location.href = environment.api.cahSignin + "client_id=" + environment.api.clientId + "&redirect_uri=" + encodedCallbackurl + "&state=DS_" + atob(sessionStorage.getItem("transactionid")) + "&nonce=prequalification_" + atob(sessionStorage.getItem("transactionid")) + "&ui_locales=" + sessionStorage.getItem("currLang") + "-CA" + "&scope=openid&prompt=login&response_type=code";
      } else if (environment.api.enable_callback == "true") {
        callbackurl = environment.backend_base_url + "authenticationUtil/auth-response";
        window.location.href = environment.api.olbSignin + "locale=" + sessionStorage.getItem("currLang") + "&transactionId=" + atob(sessionStorage.getItem("transactionid")) + "&channel=" + channel + "&callbackurl=" + callbackurl;
      } else {
        window.location.href = environment.api.olbSignin + "locale=" + sessionStorage.getItem("currLang") + "&transactionId=" + atob(sessionStorage.getItem("transactionid")) + "&channel=" + channel + "&callbackurl=" + callbackurl;
      }
    }
  }
}
